const a={primary:{variant:"contained",loading:"blue60"},highEmphasis:{variant:"contained",loading:"orange60"},secondary:{variant:"outlined",loading:"blue60"},primaryText:{variant:"text"},secondaryText:{variant:"text"}};export{a as modes};
//# sourceMappingURL=constants.js.map
